// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ba5aaad7","455":"77a6ff04","977":"999a990c"}[chunkId] + ".chunk.js";
};